import React from 'react';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import RegisterView from "./view/RegisterView";
import ThankYouView from "./view/ThankYouView";
import TermsView from "./view/TermsView";
import ContactView from "./view/ContactView";

function App() {
  return (
      <BrowserRouter>
          <Routes>
              <Route path="/" element={<RegisterView/>}/>
              <Route path="/kontakt" element={<ContactView/>}/>
              <Route path="/zapisany" element={<ThankYouView/>}/>
              <Route path="/warunki" element={<TermsView/>}/>
              {/*<Route path="/esim/:id/topups" element={<TopupOptions/>}/>*/}
          </Routes>
      </BrowserRouter>
  );
}

export default App;
